// extracted by mini-css-extract-plugin
export default {"suggestion":"suggestion--EnFg_","suggestion__count":"suggestion__count--g0B6l","suggestion__category":"suggestion__category--wOOaH"};